import { render, staticRenderFns } from "./ques-date.vue?vue&type=template&id=355a3084&scoped=true&"
import script from "./ques-date.vue?vue&type=script&lang=js&"
export * from "./ques-date.vue?vue&type=script&lang=js&"
import style0 from "./ques-date.vue?vue&type=style&index=0&id=355a3084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a3084",
  null
  
)

export default component.exports